<template>
	<header
		:class="{
			scrolled: isScrolled,
			white: this.color === 'white',
			black: this.color === 'black',
		}"
	>
		<transition name="fade">
			<div class="overlay" v-if="showSearch">
				<div class="search-block">
					<input
						class="search-input"
						type="search"
						placeholder="Search"
						v-model="searchTerm"
					/>
					<a
						class="search-submit button"
						:href="searchTerm.length > 0 ? '/search/' + searchTerm : null"
						>{{
							searchTerm.length > 0 ? 'Search' : 'Please enter a search term.'
						}}</a
					>
				</div>
			</div>
		</transition>

		<div class="container">
			<div class="menu__search__container">
				<div
					class="button__menu"
					@click="(mainNavVisible = !mainNavVisible), (showSearch = false)"
				>
					<img :src="menu_icon" alt="Menu" v-if="mainNavVisible == false" />
					<img :src="menu_icon_close" alt="Menu" v-else />
				</div>
				<div
					class="button__search"
					@click="(showSearch = !showSearch), (mainNavVisible = false)"
				>
					<img :src="search_icon" alt="Search" v-if="showSearch == false" />
					<img :src="menu_icon_close" alt="Menu" v-else />
				</div>
			</div>

			<div class="contact">
				<a :href="contact_link" class="button">Contact</a>
			</div>

			<a href="/" class="site__logo"><img :src="logo" alt="EDC" /></a>

			<transition name="fade">
				<nav class="nav-primary" v-if="mainNavVisible == true">
					<ul class="menu__parent">
						<div v-for="menu_item in menu" :key="menu_item['title']">
							<list-item :menu_item="menu_item" color="this.color"></list-item>
						</div>
					</ul>
				</nav>
			</transition>
		</div>
	</header>
</template>

<script>
import axios from 'axios';
import ListItem from '../vue/ListItem.vue';

export default {
	data() {
		return {
			menu: null,
			mainNavVisible: false,
			mobNavVisible: false,
			showSearch: false,
			searchTerm: '',
			window: {
				width: 0,
				height: 0,
			},
			topScrollThreshold: 1,
			isScrolled: false,
			headerHeight: 150,
		};
	},

	props: {
		menu_icon: {},
		menu_icon_close: {},
		search_icon: {},
		logo: {},
		contact_link: {},
		color: {},
	},

	computed: {},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},

		didScroll() {
			this.isScrolled = window.scrollY > this.topScrollThreshold;
		},
	},

	components: {
		ListItem,
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('scroll', this.didScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.didScroll);
	},
	mounted() {
		axios
			.get('/wp-json/wp/v2/menu')
			.then((response) => (this.menu = response.data));
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

header {
	position: fixed;
	top: 0;
	width: 100%;
	background: black;
	z-index: 110;
	display: grid;
	grid-template-columns: repeat(12, 1fr);
	column-gap: 0;

	&.white {
		background: white;

		.container {
			.nav-primary {
				background: rgba(255, 255, 255, 0.95);
			}
		}

		.overlay {
			background: rgba(white, 1);

			.search-block {
				.search-input {
					border: 1px solid black;
					color: black;
				}
			}
		}
	}

	&.scrolled {
		.container {
			padding: 25px 0;

			.nav-primary {
				ul {
					@media (max-width: 1366px) {
						margin-top: 100px;
					}
				}
			}
		}
	}

	.overlay {
		z-index: 0;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		background: rgba(black, 1);
		display: flex;
		flex-direction: column;

		.search-block {
			display: grid;
			grid-template-columns: repeat(12, 1fr);
			column-gap: 0;
			row-gap: 2rem;
			width: 100%;
			position: relative;
			top: calc(160px + 2rem);

			@media (max-width: 1366px) {
				grid-template-columns: repeat(12, 1fr);
				grid-column: 2 / span 10;
				top: calc(115px + 2rem);
			}

			.search-input {
				grid-column: 2 / span 10;
				border: 1px solid #e8ecef;
				appearance: none;
				background: transparent;
				font-size: 1rem;
				padding: 7px 20px;
				color: white;

				@media (max-width: 1366px) {
					grid-column: 2 / span 10;
				}

				&:focus {
					outline: none;
				}
			}

			.search-submit {
				grid-column: 10 / span 2;
				text-align: center;

				@media (max-width: 1366px) {
					height: 4rem;
					grid-column: 2 / span 10;
				}

				&:hover {
					opacity: 0.75;
				}
			}
		}
	}

	.container {
		grid-column: 2 / span 10;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: space-between;
		padding: 50px 0;
		transition: 0.2s ease all;
		display: grid;
		grid-template-columns: repeat(10, 1fr);
		column-gap: 0;

		@media (max-width: 1366px) {
			grid-column: 2 / span 10;
		}

		@media (max-width: 900px) {
			grid-template-columns: 100px 1fr 1fr;
		}

		.menu__search__container {
			display: flex;
			flex-direction: row;
			align-items: center;
			grid-column: 1 / span 1;

			div {
				&.button {
					&__menu {
						margin-right: 1rem;
						z-index: 1000;

						@media (max-width: 900px) {
							margin-right: 0.5rem;
						}

						&:hover {
							cursor: pointer;
						}

						img {
							height: 50px;

							@media (max-width: 1366px) {
								height: 40px;
							}

							// @media (max-width: 900px) {
							// 	height: 30px;
							// }
						}
					}

					&__search {
						margin-right: 1rem;
						z-index: 1000;

						@media (max-width: 900px) {
							margin-right: 0.5rem;
						}

						&:hover {
							cursor: pointer;
						}

						img {
							height: 50px;

							@media (max-width: 1366px) {
								height: 40px;
							}

							// @media (max-width: 900px) {
							// 	height: 30px;
							// }
						}
					}
				}
			}
		}

		.contact {
			grid-column: 2 / span 1;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			height: 50px;

			@media (max-width: 1366px) {
				height: 40px;
			}

			@media (max-width: 900px) {
				justify-content: flex-start;
				margin-right: 0.5rem;

				.button {
					padding: 5px 10px;
				}
			}
		}

		.site__logo {
			display: flex;
			flex-wrap: wrap;
			grid-column: 10 / span 1;

			@media (max-width: 900px) {
				grid-column: 3 / span 1;
				justify-content: flex-end;
				align-items: center;
				height: 40px;
			}

			img {
				height: 50px;

				@media (max-width: 1366px) {
					height: 40px;
				}

				@media (max-width: 900px) {
					height: 30px;
					max-width: 100%;
				}
			}
		}

		.nav-primary {
			position: fixed;
			z-index: 999;
			background: rgba(0, 0, 0, 0.95);
			width: 100%;
			height: 100vh;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			display: grid;
			grid-template-columns: repeat(12, 1fr);
			column-gap: 0;

			> ul {
				grid-column: 2 / span 10;
				list-style: none;
				display: flex;
				flex-direction: column;
				padding: 0;
				height: 100%;
				justify-content: center;
				transition: 0.2s ease all;

				@media (max-width: 1366px) {
					justify-content: flex-start;
					grid-column: 2 / span 10;
					margin-top: 140px;
				}
			}
		}
	}
}

.fade-enter-active {
	animation: fade-in 0.5s;
}

.fade-leave-active {
	animation: fade-in 0.2s reverse;
}

@keyframes fade-in {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SiteHeader.vue